import { styled } from '@linaria/react';

export const USCGComparisonSection = styled.div`
    display: flex;
    gap: 1.5rem;
    align-items: flex-start;
    margin-bottom: 1.5rem;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

export const USCGLogoSection = styled.div`
    flex: 0 0 120px;

    img {
        width: 100px;
        height: 100px;
        object-fit: contain;
    }
`;

export const USCGSearchSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1rem;

    label {
        font-weight: 600;
        color: #495057;
        margin: 0;
    }
`;

export const SearchControls = styled.div`
    display: flex;
    gap: 0.5rem;
    align-items: center;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const USCGSearchInput = styled.input`
    flex: 1;
    padding: 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 0.875rem;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
`;

// Using global TextButton for consistent styling
export { TextButton as USCGCheckButton } from '../../../../styles/button.style';

export const CompatibilityResult = styled.div`
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 4px;
    border-left: 4px solid #007bff;

    h2 {
        margin: 0 0 0.5rem 0;
        font-size: 1.1rem;
        font-weight: 700;
        color: #333;
    }

    p {
        margin: 0;
        color: #666;
        font-size: 0.875rem;
    }

    &.compatible {
        border-left-color: #28a745;
        background: #d4edda;

        h2 {
            color: #155724;
        }
    }

    &.incompatible {
        border-left-color: #dc3545;
        background: #f8d7da;

        h2 {
            color: #721c24;
        }
    }

    &.restricted {
        border-left-color: #ffc107;
        background: #fff3cd;

        h2 {
            color: #856404;
        }
    }
`;

export const USCGDocumentsSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin: 1.5rem 0;
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 4px;
`;

export const DocumentLink = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;

    img {
        width: 40px;
        height: 40px;
        object-fit: contain;
    }

    a {
        color: #007bff;
        text-decoration: none;
        font-weight: 500;

        &:hover {
            text-decoration: underline;
        }
    }
`;

export const USCGGroupInfo = styled.div`
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid #dee2e6;

    h3 {
        font-size: 1.1rem;
        font-weight: 700;
        color: #333;
        margin: 0 0 1rem 0;
    }

    p {
        margin: 0 0 1rem 0;
        color: #495057;
    }
`;

export const USCGTable = styled.div`
    border: 1px solid #dee2e6;
    border-radius: 4px;
    overflow: hidden;

    .table-header {
        display: grid;
        grid-template-columns: 1fr;
        background: rgb(238 238 238);
        padding: 0.75rem;
        font-weight: 700;
        color: #495057;
        border-bottom: 2px solid #dee2e6;
    }

    .table-header.exceptions-header {
        grid-template-columns: 60% 40%;
    }

    .table-header.inter-products-header {
        grid-template-columns: 40% 20% 40%;
    }

    .table-row {
        display: grid;
        grid-template-columns: 1fr;
        padding: 0.75rem;
        border-bottom: 1px solid #dee2e6;
        transition: background 0.15s;

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            background: #f8f9fa;
        }

        span {
            color: #333;
        }

        a {
            color: #007bff;
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .table-row.exceptions-row {
        grid-template-columns: 60% 40%;
    }

    .table-row.inter-products-row {
        grid-template-columns: 40% 20% 40%;
    }
`;

export const ExceptionsSection = styled.div`
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid #dee2e6;

    h3 {
        font-size: 1.1rem;
        font-weight: 700;
        color: #333;
        margin: 0 0 1rem 0;
    }
`;

export const ExceptionsTableContainer = styled.div`
    margin-bottom: 2rem;
`;

// Typeahead styles
export const SearchInputContainer = styled.div`
    position: relative;
    flex: 1;
`;

export const TypeaheadDropdown = styled.ul`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    background: white;
    border: 1px solid #ced4da;
    border-top: none;
    border-radius: 0 0 4px 4px;
    max-height: 200px;
    overflow-y: auto;
    margin: 0;
    padding: 0;
    list-style: none;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const TypeaheadItem = styled.li<{ isHighlighted?: boolean }>`
    padding: 0.5rem 0.75rem;
    cursor: pointer;
    background: ${({ isHighlighted }) => (isHighlighted ? '#e9ecef' : 'white')};
    border-bottom: 1px solid #f0f0f0;
    font-size: 0.875rem;
    color: #333;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #e9ecef;
    }

    .product-name {
        font-weight: 500;
    }

    .product-category {
        font-size: 0.75rem;
        color: #6c757d;
        margin-left: 0.5rem;
    }
`;

export const TypeaheadNoResults = styled.li`
    padding: 0.5rem 0.75rem;
    font-size: 0.875rem;
    color: #6c757d;
    font-style: italic;
`;
